<template>
  <div class="px-2 py-1 flex flex-row">
    <span class="font-light">{{ item.location }}</span><span class="ml-2 font-medium">{{ item.destination }}</span>
  </div>
</template>

<script>
export default {
name: "fleet-column-destination-small",
  props: ['column', 'item'],
  methods: { },
}
</script>

<style scoped>

</style>